import { Box, Divider, Theme, Typography, useTheme } from '@mui/material';
import PremiumIcon2x from '/public/icons/common/premium-plan-2x.svg';

import React from 'react';
import { format } from 'date-fns';
import { PlanNameEnum } from '../../enums/UserCurrentEnums';
import { UserCurrentQuery } from '../../redux/services/auth/auth.generated';

interface SubscriptionDetailsProps {
  userData: UserCurrentQuery;
}
const SubscriptionDetails: React.FC<SubscriptionDetailsProps> = ({
  userData,
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);

  const activeSubscription = userData?.userCurrent?.activeSubscription;
  const userEmail = userData?.userCurrent?.email || '';

  //render
  const getPlanDescription = (planName: string | undefined) => {
    switch (planName) {
      case PlanNameEnum.Monthly:
        return 'Monthly recurring';
      case PlanNameEnum.Yearly:
        return '1 year of Ragya';
      default:
        return '';
    }
  };

  const getPlanDetails = (header: string, value: string) => (
    <Box sx={styles.planContainer}>
      <Typography
        variant='subtitle1'
        fontWeight={400}
        sx={styles.planHeaderContainer}
      >
        {header}
      </Typography>
      <Typography variant='subtitle1' fontWeight={700}>
        {value}
      </Typography>
    </Box>
  );
  return (
    <Box
      sx={{
        borderRadius: '16px',
        color: 'white',
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        // flexDirection: isMobile ? 'column' : 'row',
        gap: 1,
        background: `linear-gradient(180deg, #0C4141 0%, #356969 100%)`,
      }}
    >
      <PremiumIcon2x />
      <Typography variant='h2' fontSize={32}>
        You are Premium!
      </Typography>
      <Typography variant='subtitle2' color={theme.ragyaPalette.gray1}>
        Your Ragya premium is associated with {userEmail}.
      </Typography>
      <Divider sx={{ backgroundColor: theme.ragyaPalette.gray7 }} />
      {getPlanDetails(
        'Your current plan',
        getPlanDescription(activeSubscription?.subscriptionPlan?.name)
      )}
      {getPlanDetails(
        'Valid till',
        format(new Date(activeSubscription?.expiresAt), 'do MMMM yyyy')
      )}
    </Box>
  );
};

export default SubscriptionDetails;

const useStyles = (theme: Theme) => ({
  container: {
    borderRadius: '16px',
    color: 'white',
    p: 4,
    display: 'flex',
    flexDirection: 'column',
    // flexDirection: isMobile ? 'column' : 'row',
    gap: 1,
    background: `linear-gradient(180deg, #0C4141 0%, #356969 100%)`,
  },
  premiumText: {},
  planHeaderContainer: {
    width: 103,
  },
  planContainer: { display: 'flex', flex: 1, gap: 2 },
});
